import React, { useState } from 'react'
import { Moment } from 'moment'
import { DayPickerSingleDateController as DP } from 'react-dates'
import styled from 'styled-components'

const DayPickerWrapper = styled.div<{ error?: boolean }>`
  .DayPicker_transitionContainer {
    border: 1px solid
      ${({ error, theme }) =>
        error ? theme.colors.textError : theme.colors.backgroundSecondary};
    box-sizing: border-box;
    border-radius: 4px;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:hover {
    background-color: ${({ theme }) => theme.colors.borderSecondary};
    border: none;
  }
  .DateInput {
    &_input__focused {
      border-bottom-color: ${({ theme }) => theme.colors.borderSecondary};
    }
  }
  .DayPicker_weekHeader_ul {
    margin: 0;
    margin-top: -3px;
  }
`

interface DayPickerProps {
  date: Moment | null
  setDate: (date: Moment | null) => void
  error?: boolean
  className?: string
  [key: string]: any
}

export default function DayPicker({
  date,
  setDate,
  error,
  className,
  ...rest
}: DayPickerProps) {
  const [focused, setFocused] = useState<boolean | null>(false)
  return (
    <DayPickerWrapper error={error} className={className} {...rest}>
      <DP
        date={date}
        onDateChange={setDate}
        focused={!!focused}
        onFocusChange={({ focused: changedFocus }) => setFocused(changedFocus)}
        numberOfMonths={1}
        noBorder
        hideKeyboardShortcutsPanel
        {...rest}
      />
    </DayPickerWrapper>
  )
}
